import {useMemo} from 'react';

import {AEM_DEVICE_SETTINGS_TYPES} from '@/consts/aem/aemDeviceSettingsTypes';
import appContent from '@/services/content/appContent';

export const useLockUnlockSettingContent = () => {
    return useMemo(() => {
        const deviceSettingsContent = appContent.getDeviceSettingContentList();

        for (const group of deviceSettingsContent) {
            const lockUnlockItem = group.items?.find((item) => item.type === AEM_DEVICE_SETTINGS_TYPES.LOCK_UNLOCK);

            if (lockUnlockItem) {
                return lockUnlockItem;
            }
        }
        return null;
    }, []);
};

export const useSettingsContent = () => {
    return useMemo(() => {
        const deviceSettingsContent = appContent.getDeviceSettingContentList();
        const sortedContent = deviceSettingsContent.map((group) => {
            const sortedItems = [...(group.items || [])].sort((a, b) => (a.order || 0) - (b.order || 0));

            return {
                ...group,
                items: sortedItems,
            };
        });

        return sortedContent.sort((a, b) => (a.order || 0) - (b.order || 0));
    }, []);
};

export const useSettingsContentWithoutLockUnlock = () => {
    return useMemo(() => {
        const deviceSettingsContent = appContent.getDeviceSettingContentList();
        const contentWithoutLockUnlock = deviceSettingsContent.map((group) => {
            const filteredItems =
                group.items?.filter((item) => item.type !== AEM_DEVICE_SETTINGS_TYPES.LOCK_UNLOCK) || [];

            const sortedItems = filteredItems.sort((a, b) => (a.order || 0) - (b.order || 0));

            return {
                ...group,
                items: sortedItems,
            };
        });
        const nonEmptyGroups = contentWithoutLockUnlock.filter((group) => group.items.length > 0);

        return nonEmptyGroups.sort((a, b) => (a.order || 0) - (b.order || 0));
    }, []);
};
